<template>
  <div class="resident-list">
    <section class="list-header">
      <div class="title-row">
        <v-btn icon class="back-button" @click="$router.push('/home')">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <h1>Relatórios</h1>
      </div>
      <v-btn icon class="refresh-button" @click="load">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </section>

    <section v-if="!items.length && !loading" class="empty-panel">
      <v-icon color="primary" size="36">mdi-file-chart-outline</v-icon>
      <strong>Nenhum relatório publicado</strong>
      <span>O resumo mensal do local aparecerá aqui.</span>
    </section>

    <article v-for="report in items" :key="report.id" class="report-card">
      <div class="report-heading">
        <span>{{ report.reference_month }}</span>
        <strong>{{ report.title }}</strong>
        <p>{{ report.summary }}</p>
      </div>
      <div class="metric-grid">
        <div v-for="metric in metrics(report)" :key="metric.label">
          <strong>{{ metric.value }}</strong>
          <span>{{ metric.label }}</span>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "BoaruaMonthlyReports",
  data() {
    return {
      loading: false,
      items: [],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      const profile = JSON.parse(localStorage.getItem("associationProfile") || "{}");
      this.loading = true;
      try {
        const response = await axios.get("/monthly-reports", {
          params: { tenant_id: profile.tenant_id, limit: 24, search: JSON.stringify({ status: "published" }) },
        });
        this.items = response.data.content.data || response.data.content || [];
      } finally {
        this.loading = false;
      }
    },
    metrics(report) {
      try {
        const raw = JSON.parse(report.metrics_json || "{}");
        return [
          { label: "moradores", value: raw.members || 0 },
          { label: "chamados", value: raw.demands_open || 0 },
          { label: "rondas", value: raw.patrol_checkins || 0 },
          { label: "alertas", value: raw.security_alerts || 0 },
        ];
      } catch (error) {
        return [];
      }
    },
  },
};
</script>

<style scoped lang="scss">
.resident-list {
  min-height: 100%;
  padding: 0 16px 18px;
  color: #111827;
}

.list-header {
  min-height: 72px;
  margin: 0 -16px 12px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  border-bottom: 1px solid #edf0ed;

  h1 {
    margin: 0;
    font-size: 24px;
  }
}

.title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.back-button,
.refresh-button {
  background: #f5f7f5;
  border: 1px solid #dfe7df;
  border-radius: 12px;
}

.report-card,
.empty-panel {
  background: #ffffff;
  border: 1px solid #e1e8e2;
  border-radius: 16px;
}

.report-card {
  margin-bottom: 10px;
  padding: 15px;
}

.report-heading {
  span {
    color: #057a3d;
    font-size: 12px;
    font-weight: 900;
  }

  strong {
    display: block;
    margin-top: 4px;
    font-size: 18px;
  }

  p {
    margin: 6px 0 0;
    color: #66736b;
    font-size: 13px;
  }
}

.metric-grid {
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;

  div {
    padding: 10px;
    background: #f4f8f5;
    border-radius: 12px;
  }

  strong,
  span {
    display: block;
  }

  span {
    color: #66736b;
    font-size: 12px;
  }
}

.empty-panel {
  min-height: calc(100vh - 184px);
  padding: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7px;
  text-align: center;

  span {
    color: #66736b;
    font-size: 13px;
  }
}
</style>
